import NoRecordFound from "../../../../../components/ui/noRecordFound/NoRecordFound";
import TVOCCertificate from "./tvoc/TVOCCertificate";
import GWPGeneralCertificate from "./gwpGeneral/GWPGeneralCertificate";
import GWPConcreteCertificate from "./gwpConcrete/GWPConcreteCertificate";
import CommonCertificateGrouping from "./common/CommonCertificateGrouping";
import { CERTIFICATE_TYPE } from "./components/certificateTypes";

const CERTIFICATE_IDS_BY_TYPE = {
  [CERTIFICATE_TYPE.COMMON]: [1, 2],
  [CERTIFICATE_TYPE.GWP_CONCRETE]: [3, 4],
  [CERTIFICATE_TYPE.GWP_GENERAL]: [5, 6],
  [CERTIFICATE_TYPE.TVOC]: [7, 8],
};

const PAGE_BY_TYPE = {
  [CERTIFICATE_TYPE.COMMON]: CommonCertificateGrouping,
  [CERTIFICATE_TYPE.GWP_CONCRETE]: GWPConcreteCertificate,
  [CERTIFICATE_TYPE.GWP_GENERAL]: GWPGeneralCertificate,
  [CERTIFICATE_TYPE.TVOC]: TVOCCertificate,
};

const getCertificateType = (certificateId) =>
  Object.keys(CERTIFICATE_IDS_BY_TYPE).find((type) =>
    CERTIFICATE_IDS_BY_TYPE[type].includes(Number(certificateId))
  );

const CertificateGroupingView = ({ certificateId }) => {
  const Page = PAGE_BY_TYPE[getCertificateType(certificateId)];
  return Page ? <Page /> : <NoRecordFound />;
};

export default CertificateGroupingView;